// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__3mjap","flexItems":"Modal_flexItems__evWVe","actions":"Modal_actions__2n4Eg"};